import { FlowExecutionStepReadDetail } from "@hilos/types/private-schema";
import HTTPResponseRenderResponse from "src/components/HTTPResponseRender/HTTPResponseRenderResponse";

interface FlowExecutionStepActiveCampaignAutomationStartDetailProps {
  executionStep: FlowExecutionStepReadDetail;
}

export default function FlowExecutionStepActiveCampaignAutomationStartDetail({
  executionStep,
}: FlowExecutionStepActiveCampaignAutomationStartDetailProps) {
  return (
    <HTTPResponseRenderResponse
      response={executionStep.execution_result?.response}
    />
  );
}
